export const getUpgradeError = (err) => {
  if (typeof err !== 'string' || err.split('::').length !== 2) {
    return null;
  }
  return err.split('::')[1];
}
